export default function FormField({ label, help, error, children, className = "" }) {
  return (
    <div className={["mb-4", className].join(" ")}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
        </label>
      )}
      {children}
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      {help && !error && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{help}</p>}
    </div>
  );
}
